export type ApiPagination = {
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
};

export type NormalizedPagination = {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type PaginatedResult<T> = {
  items: T[];
  pagination: NormalizedPagination;
};

export const normalizePagination = (p: ApiPagination): NormalizedPagination => ({
  total: p.total,
  limit: p.limit,
  page: Math.floor(p.offset / p.limit) + 1,
  totalPages: Math.ceil(p.total / p.limit) || 1,
});
